exports = module.exports = require("../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".uib-time input {\n  width: 50px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/angular-ui-bootstrap/src/timepicker/timepicker.css
// module id = 577
// module chunks = 1